import auth from "./auth";
import Vue from "vue";
import store from "../store";

Vue.axios.interceptors.response.use((response) => { // intercept the global error
    return response
}, (error) => {
    if(error.response) {
        if (error.response.status === 401) {
            let arr = window.location.pathname.split("/");
            if (arr[1] === 'admin') {
                localStorage.removeItem("vue-authenticate.vueauth_access_token")
                window.location =  '/admin/login'
            } else if (arr[1] === 'pwa') {
                localStorage.removeItem("pwa")
                window.location =  '/pwa/login'
            } else {
                localStorage.removeItem("client-area")
                window.location =  '/login'
            }
        }

        if(error.response.status === 403 && window.location.pathname.includes('pwa')) {
            localStorage.removeItem('pwa')
            window.location = '/pwa/login'
        }

        if (error.response.status === 422) {
            store.dispatch('alerts/error', 'Le formulaire n\'a pas pu être validé. Merci de le corriger avant de le renvoyer');
        }

        if (error.response.status === 500) {
            let msg = error.response.data ? error.response.data.msg : false
            if (!msg) {
                msg = 'Une erreur interne au serveur est survenue'
            }
            store.dispatch('alerts/error', msg);
        }
    }

    // Do something with response error
    return Promise.reject(error)
})

export default auth
